import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { generalValidator } from '../../../../../../libs/utility/validators/GeneralValidator';
import { componentKey, setRecipientOptionalInformation } from '../../AddRecipientSlice';
import { componentKey as authenticationSliceKey } from '../../../../authentication/AuthenticationSlice';
import commonStyles from "../../AddRecipient.styles"
import Heading from '../../../../../components/heading/Heading';
import { HEADING } from '../../../../../components/heading/constants/constants';
import TextInput from '../../../../../components/input/textinput/TextInput';
import styles from '../../../addpayernew/createone/getoptionalinfo/GetOptionalInfo.styles';

export default function GetOptionalInfo({renderForSingleView = false}) {

    const { recipientOptionalInformation } = useSelector((state) => state[componentKey]);
    const { signedInUser } = useSelector(state => state[authenticationSliceKey])
    const dispatch = useDispatch();

    const onChangehandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setRecipientOptionalInformation({ [name]: { value, errors, rules } }));
        } else {
            dispatch(setRecipientOptionalInformation({ [name]: { value } }));
        }
    };

    return (
        <>
            <div style={commonStyles.container}>
                <div>
                    <Heading type={HEADING.H1}>Do any of these uncommon scenarios apply to you?</Heading>
                    {!signedInUser?.IsRecipientClient && <p>{`It’s OK to skip this step. You can always add this later !`}</p>}
                </div>

                <div style={commonStyles.formContainer}>
                    <div style={styles.formRow}>
                        <div style={styles.recipientFieldsContainer}>
                            <div style={styles.recipientBatch1Container}>
                                <TextInput
                                    name="AttentionTo"
                                    label="Attention To"
                                    placeHolder="Enter attention to"
                                    value={recipientOptionalInformation.AttentionTo?.value}
                                    onChangeCb={onChangehandler}
                                    errors={recipientOptionalInformation.AttentionTo?.errors}
                                    rules={recipientOptionalInformation?.AttentionTo?.rules}
                                    formSubmitted={recipientOptionalInformation.allRequiredFieldsTouched}
                                />
                            </div>
                            <div style={styles.recipientBatch2Container}>
                                <TextInput
                                    name="Isrecipientclient"
                                    label="Recipient Client ID"
                                    placeHolder="Enter Recipient Client ID"
                                    value={recipientOptionalInformation.Isrecipientclient?.value}
                                    onChangeCb={onChangehandler}
                                    errors={recipientOptionalInformation.Isrecipientclient?.errors}
                                    rules={recipientOptionalInformation?.Isrecipientclient?.rules}
                                    formSubmitted={recipientOptionalInformation.allRequiredFieldsTouched}
                                />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}
